export default __webpack_public_path__ + "components/icon/static/cards-c84260ca00c5fa70f892df95950ba967.svg";